<div class="coming-soon">
  <div class="content">
    <mat-icon class="icon" aria-hidden="true">construction</mat-icon>
    
    <h1>{{ 'COMING_SOON.TITLE' | translate }}</h1>
    <p class="subtitle">{{ 'COMING_SOON.SUBTITLE' | translate }} ✨</p>
    
    <p class="message">
      {{ 'COMING_SOON.THANKS' | translate }}<br>
      {{ 'COMING_SOON.RETURN_MESSAGE' | translate }}
    </p>
  </div>
</div>